<template>
  <div class="form-add-participant">
    <v-form autocomplete="off" @submit.prevent="handleSubmitForm">
      <v-card>
        <v-card-title>
          {{
            id
              ? form.contact.name
              : $capitalize($tc("model.participants_new_participant"))
          }}
          <v-spacer></v-spacer>
          <v-btn @click="handleCloseForm" icon>
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <ValidationObserver ref="form" v-slot="{ invalid }">
            <ValidationProvider
              name="contact_id"
              :rules="{
                required: !!!id
              }"
              v-slot="{ errors }"
            >
              <select-contact
                v-model="contact"
                item-text="name"
                :label="
                  $capitalize($tc('model.participants_contact_of_participant'))
                "
                :placeholder="
                  $capitalize($tc('model.participants_search_contacts'))
                "
                :error-messages="errors"
                :disabled="!!id"
              />
            </ValidationProvider>

            <ValidationProvider
              name="type"
              rules="required|max:45"
              v-slot="{ errors }"
            >
              <v-text-field
                :label="
                  $capitalize($tc('model.participants_type_of_participant'))
                "
                name="type"
                :error-messages="errors"
                v-model="type"
                prepend-icon="mdi-tag-text-outline"
                :hint="
                  $capitalize($tc('model.participants_field_type_participant'))
                "
                :disabled="checkInsured()"
              ></v-text-field>
            </ValidationProvider>
          </ValidationObserver>
          <v-alert
            color="blue lighten-3"
            icon="mdi-information"
            v-if="checkInsured()"
            >{{
              $capitalize($tc("model.participants_restrictions_has_change"))
            }}</v-alert
          >
        </v-card-text>
        <v-card-actions v-if="!checkInsured()">
          <v-spacer></v-spacer>
          <v-btn @click="handleCloseForm" text>{{
            $capitalize($tc("model.participants_cancel_button"))
          }}</v-btn>
          <v-btn
            type="submit"
            color="primary"
            :disabled="checkInsured()"
            :loading="loading"
            >{{ $capitalize($tc("model.participants_save_button")) }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-form>
  </div>
</template>

<script>
import SelectContact from "@/components/SelectContact";

export default {
  components: { SelectContact },
  data: () => ({
    contact: null,
    type: "",
    loading: false,
    id: null
  }),
  props: ["form"],
  model: {
    prop: "form",
    event: "change"
  },
  methods: {
    resetForm() {
      this.contact = null;
      this.type = "";
      this.id = null;

      this.$emit("change", {
        contact: null,
        type: ""
      });
      this.$refs.form.reset();
    },
    handleCloseForm() {
      this.resetForm();
      this.$emit("close");
    },
    async handleSubmitForm() {
      const validation = await this.$refs.form.validate();
      if (validation) {
        const payload = {
          contact_id: this.contact?.id,
          lead_id: this.lead.id,
          type: this.type
        };
        try {
          this.loading = true;
          const response = this.id
            ? await this.updateParticipant(payload, this.id)
            : await this.storeParticipant(payload);
          this.$store.commit("sendMessage", {
            text: `Registro adicionado com sucesso!`,
            color: "success"
          });
          this.$emit("change", {
            ...response.data
          });
          this.$emit(this.id ? "update" : "create", response.data);
          this.handleCloseForm();
        } catch (error) {
          if (error.response) {
            switch (error.response.status) {
              case 422:
                this.$refs.form.setErrors(error.response.data.errors);
                break;

              case 400:
                this.$store.commit("sendMessage", {
                  text: error.response.data.message,
                  color: "red"
                });
                break;

              default:
                this.$store.commit("sendMessage", {
                  text: "Algo de errado aconteceu, tente novamente mais tarde",
                  color: "red"
                });
                break;
            }
          } else {
            this.$store.commit("sendMessage", {
              text: error.getMessage(),
              color: "red"
            });
          }
        } finally {
          this.loading = false;
        }
      }
    },
    storeParticipant(payload) {
      return this.$http.post("/participants", payload);
    },
    updateParticipant(payload, id) {
      return this.$http.put("/participants/" + id, payload);
    },
    checkInsured() {
      if (this.contact?.id) {
        return this.contact?.id === this.$store.getters.getLead.insured_id;
      }

      return false;
    }
  },
  watch: {
    form: function(value) {
      if (value) {
        this.type = value.type;
        this.contact = value.contact;
        this.id = value.id;
        this.$refs.form.reset();
      } else if (value == null) {
        this.resetForm();
      }
    }
  },
  computed: {
    lead: function() {
      return this.$store.getters.getLead;
    }
  },
  created() {
    if (this.form) {
      this.type = this.form.type;
      this.contact = this.form.contact;
      this.id = this.form.id;
    }
  }
};
</script>
